import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 384 512" {...props}><path d="M130 391.5c-13.5 0-13.5-14.6-13.5-14.6 0-29.1-3.8-45-32.4-72.8a180.62 180.62 0 01-53.9-130C30.2 77.7 102.5-.5 192-.5s161.8 78.2 161.8 174.7c.4 48.9-19.1 95.9-53.9 130.2-28.6 27.5-32.4 43.4-32.4 72.8 0 0 0 14.3-13.5 14.3h-62zm137.5 55.3h-151v-33.7h151zm0 64.7h-151v-33.4h151z" /></svg>);